import { ActivityOperationType } from "app/core/modal/activity-operation-type";

export class RevertDataModel{
    id: number;
    locationExternalId: string;
    operation:ActivityOperationType
 }